import { Directive, Input } from '@angular/core';
import { SwiperSlideDirective } from 'swiper/angular';

@Directive({
    selector: 'ng-template[carouselSlide],ng-template[swiperSlide]',
    standalone: false
})
export class CarouselSlideDirective extends SwiperSlideDirective {
    // You can't use `[style.--swiper-theme-color]` in the template
    // Use only simple string values
    //
    // @example
    // ```html
    // <ng-template carouselSlide [style]="'--swiper-theme-color: #fff'">
    // ```
    @Input()
    style?: string;
}
